export default __webpack_public_path__ + "images/E9.01ecd99.png";